import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";

interface Props {
  clients: any[];
  onClose: () => void;
}

export default function ClientPickerSheet({ clients, onClose }: Props) {
  const navigate = useNavigate();

  const handlePick = (client: any) => {
    onClose();
    if (client.activeShiftId) {
      navigate(`/shifts/${client.activeShiftId}/active`);
    } else {
      navigate(`/clients/${client.id}/shift?mode=manual`);
    }
  };

  return (
    <div
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
      style={{
        position: "fixed", inset: 0, background: "rgba(0,0,0,0.3)", zIndex: 60,
        display: "flex", alignItems: "center", justifyContent: "center",
        padding: "24px 16px",
        backdropFilter: "blur(4px)",
      }}
    >
      <div onClick={(e) => e.stopPropagation()} style={{
        width: "100%", maxWidth: 400,
        background: "var(--color-surface)", borderRadius: "var(--radius-lg)",
        boxShadow: "0 8px 24px rgba(27,42,74,0.12)",
        maxHeight: "calc(100vh - 48px)", overflowY: "auto", WebkitOverflowScrolling: "touch",
        padding: "0",
      }}>
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "16px 20px 12px",
          borderBottom: "1px solid var(--color-border)",
        }}>
          <span style={{ fontSize: 17, fontWeight: 600 }}>Log a shift for...</span>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", padding: 4 }}>
            <X size={20} color="var(--color-text-muted)" />
          </button>
        </div>

        <div style={{ padding: "8px 0" }}>
          {clients.map((client) => {
            const initials = (client.first_name?.[0] || "") + (client.last_name?.[0] || "");
            return (
              <button
                key={client.id}
                onClick={() => handlePick(client)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 14,
                  width: "100%",
                  padding: "14px 20px",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  textAlign: "left",
                  minHeight: 56,
                }}
              >
                <div style={{
                  width: 44,
                  height: 44,
                  borderRadius: "50%",
                  background: "var(--color-primary-light)",
                  color: "var(--color-primary)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: 700,
                  fontSize: 15,
                  flexShrink: 0,
                }}>
                  {initials.toUpperCase()}
                </div>
                <div>
                  <div style={{ fontWeight: 600, fontSize: 15 }}>
                    {client.first_name} {client.last_name || ""}
                  </div>
                  <div style={{ fontSize: 13, color: "var(--color-text-muted)" }}>
                    ${client.rate_weekday}/hr
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
